// extracted by mini-css-extract-plugin
export default {"header":"Header_header__NkJGF","storeIcon":"Header_storeIcon__x-mKF","storeInfo":"Header_storeInfo__ILL8O","onlineShop":"Header_onlineShop__JEdGG"};